"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            var ModulePaneModule = /** @class */ (function (_super) {
                __extends(ModulePaneModule, _super);
                function ModulePaneModule() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.Shortcuts = $dyn.extendPrototype($dyn.ui.Control.prototype.Shortcuts, {
                        Activate: {
                            Handler: function () { _this.onClick(); },
                            Keys: { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] },
                            ShowToUser: false,
                        },
                    });
                    _this.onClick = function (event) {
                        if (event && event.target && event.type === "click") {
                            var selectPosition = Array.prototype.indexOf.call(event.target.parentElement.children, event.target);
                            _this.props.SetSelectedPaneItem(selectPosition);
                        }
                        if (!_this.props.isActive || !_this.props.PaneIsExpanded) {
                            DynReact.ModuleStore.changeActiveModule(_this.props.MenuItemName);
                            _this.props.ExpandPane();
                        }
                        else if (_this.props.isActive && _this.props.PaneIsExpanded) {
                            _this.props.ExpandPane();
                        }
                        else {
                            DynReact.ModuleStore.changeActiveModule(null);
                        }
                    };
                    _this.keyHandler = function (event) {
                        $dyn.util.handleShortcuts(_this, event.nativeEvent);
                    };
                    return _this;
                }
                ModulePaneModule.prototype.componentDidMount = function () {
                    this.element.dynContext = { current: this };
                    // auto open flyout but only for non phone devices or single column mode
                    if ((!this.props.isPhoneDevice && !this.props.isSingleColumnMode) && this.props.isActive) {
                        DynReact.ModuleStore.changeActiveModule(this.props.MenuItemName);
                        this.props.ExpandPane();
                    }
                };
                ModulePaneModule.prototype.componentDidUpdate = function () {
                    this.element.dynContext = { current: this };
                };
                ModulePaneModule.prototype.render = function () {
                    var _this = this;
                    var classes = "modulesPane-module";
                    classes = this.props.isActive ? classes += " modulesPane-isActive" : classes;
                    return (React.createElement("a", { "aria-posinset": this.props.Posinset, "aria-selected": this.props.Selected, "aria-setsize": this.props.Setsize, "aria-level": 2, className: classes, "data-dyn-selected": this.props.Selected, "data-dyn-title": this.props.Label, onClick: this.onClick, onKeyDown: this.keyHandler, onMouseEnter: this.onmouseenter, ref: function (ref) { return _this.element = ref; }, role: "treeitem", tabIndex: 0 }, this.props.Label));
                };
                ModulePaneModule.prototype.onmouseenter = function (event) {
                    $dyn.superTooltip.tryOpenSuperTooltip(event.target);
                };
                return ModulePaneModule;
            }(React.Component));
            UI.ModulePaneModule = ModulePaneModule;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ModulePaneModule.js.map
